import { ActivatedRouteSnapshot, ResolveFn, Router, RouterStateSnapshot } from "@angular/router";
import { EMPTY, Observable, switchMap, take } from "rxjs";
import { environment } from "src/environments/environment";
import { ResolverHelper } from "./resolver.helper";
import { EVServiceType } from "src/util/auth0/models/evServiceType.enum";
import { AuthService } from "@auth0/auth0-angular";
import { inject } from "@angular/core";

export const SearchpageResolver: ResolveFn<any> = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> => {
    const authService = inject(AuthService);
    const router = inject(Router);
    const queryParams = route.queryParams;
    const hasQuery = queryParams.hasOwnProperty("q");

    if (hasQuery) {
        return ResolverHelper.hasPermission(authService, EVServiceType.Internal_Debug).pipe(
            take(1),
            switchMap((hasDebugRole) => {
                const q: string = queryParams["q"] != null ? queryParams["q"].toString() : "";
                if (hasDebugRole) {
                    router.navigate(["/searchpage"], { queryParams: { searchstring: q } });
                } else {
                    const url = environment.evwebUrl + "/searchpage;searchString=" + encodeURIComponent(q) + ";doSearch=true;";
                    window.open(url, "_self");
                }
                return EMPTY;
            }),
        );
    } else {
        return ResolverHelper.redirectToFrontPage(authService, router);
    }
};
